import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=3aaf4f54&scoped=true&"
import script from "./search.component.vue?vue&type=script&lang=js&"
export * from "./search.component.vue?vue&type=script&lang=js&"
import style0 from "./search.component.vue?vue&type=style&index=0&id=3aaf4f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf4f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaf4f54')) {
      api.createRecord('3aaf4f54', component.options)
    } else {
      api.reload('3aaf4f54', component.options)
    }
    module.hot.accept("./search.component.vue?vue&type=template&id=3aaf4f54&scoped=true&", function () {
      api.rerender('3aaf4f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/search.component.vue"
export default component.exports